import React from 'react';
import { Row, Col, Space, Typography, Divider } from 'antd';
import {
  WhatsAppOutlined, InstagramOutlined, FacebookOutlined, MailOutlined,
  PhoneOutlined, EnvironmentOutlined, AndroidFilled, AppleFilled,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { WHATSAPP_URL, ANDROID_APP_URL, IOS_APP_URL } from '../config/app.config';
import '../styles/Footer.css';

const { Text, Title } = Typography;

const Footer: React.FC = () => {
  return (
    <footer className="footer-section" style={{ padding: '60px 20px 20px' }}>
      <div className="footer-inner">
        <Row gutter={[40, 40]}>
          <Col xs={24} sm={12} md={6}>
            <Title level={4} className="font-poppins text-white footer-brand-title">
              <img src={`${process.env.PUBLIC_URL}/delhi36-white-logo.png`} alt="" className="footer-brand-logo" />
              Delhi36 F2K
            </Title>
            <Text className="footer-brand-text">
              Farm to Kitchen — your trusted source for farm-fresh vegetables delivered straight from the farm to your family.
            </Text>
            <div className="footer-social-links">
              <Space size={12}>
                <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="footer-social-btn wa">
                  <WhatsAppOutlined />
                </a>
                <a href="https://www.instagram.com/ca.re8089/" target="_blank" rel="noreferrer" className="footer-social-btn ig">
                  <InstagramOutlined />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61589996307712" target="_blank" rel="noreferrer" className="footer-social-btn fb">
                  <FacebookOutlined />
                </a>
                <a href="mailto:care@delhi36f2k.com" className="footer-social-btn mail">
                  <MailOutlined />
                </a>
              </Space>
            </div>

            <div className="footer-app-badges">
              <a href={ANDROID_APP_URL} target="_blank" rel="noopener noreferrer" className="footer-app-badge">
                <AndroidFilled className="footer-app-badge-icon" />
                <span className="footer-app-badge-text">
                  <small>GET IT ON</small>
                  Google Play
                </span>
              </a>

              <a href={IOS_APP_URL} target="_blank" rel="noopener noreferrer" className="footer-app-badge">
                <AppleFilled className="footer-app-badge-icon" />
                <span className="footer-app-badge-text">
                  <small>DOWNLOAD ON THE</small>
                  App Store
                </span>
              </a>
            </div>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-col-title">Quick Links</Title>
            <Space direction="vertical" size={8}>
              {[
                { label: 'Home',             to: '/' },
                { label: 'Shop Vegetables',  to: '/shop' },
                { label: 'Our Farmers',      to: '/our-farmers' },
                { label: '🏆 Winners',       to: '/winners' },
                { label: 'Cart',             to: '/cart' },
                { label: 'My Account',       to: '/dashboard' },
                { label: 'Privacy Policy',   to: '/privacy' },
                { label: 'Terms of Service', to: '/terms' },
                { label: 'Delete My Account', to: '/delete-account' },
              ].map(link => (
                <Link key={link.label} to={link.to} className="footer-nav-link">
                  → {link.label}
                </Link>
              ))}
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-col-title">Delivery Areas</Title>
            <Space orientation="vertical" size={4}>
              {['Delhi (All Areas)', 'Noida & Greater Noida', 'Gurgaon / Gurugram', 'Faridabad', 'Ghaziabad'].map(area => (
                <Text key={area} className="footer-area-text">📍 {area}</Text>
              ))}
              {/* Slots are per-area now (daily in some pincodes, weekends in
                  others) and configurable, so no single time can be stated here.
                  Checkout shows the real ones for the chosen address. */}
              <Text className="footer-timing-text">🕐 Daily &amp; weekend slots — shown at checkout</Text>
            </Space>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <Title level={5} className="footer-col-title">Contact Us</Title>
            <Space orientation="vertical" size={12}>
              <Space>
                <PhoneOutlined className="icon-light-green" />
                <Text className="footer-contact-text">+91 97168 24930</Text>
              </Space>
              <Space>
                <WhatsAppOutlined className="icon-wa" />
                <Text className="footer-contact-text">WhatsApp Order</Text>
              </Space>
              <Space>
                <MailOutlined className="icon-light-green" />
                <Text className="footer-contact-text">care@delhi36f2k.com</Text>
              </Space>
              <Space align="start">
                <EnvironmentOutlined className="icon-light-green" />
                <Text className="footer-contact-timing-text">
                  Order Mon–Fri<br />Delivery Sat & Sun
                </Text>
              </Space>
            </Space>
          </Col>
        </Row>

        <Divider className="footer-divider" />

        <Row justify="space-between" align="middle" gutter={[16, 16]}>
          <Col>
            <Text className="footer-copyright">
              {/* The registered entity behind the Delhi36 F2K brand. Kept as
                  visible text (not an image) and on every page, because business
                  verification — Meta's, Razorpay's — checks the site for the
                  legal name and can't read it out of a logo. */}
              © 2026 <strong>Delhi 36 Olericulturists &amp; Suppliers</strong> · trading as Delhi36 F2K · All rights reserved
            </Text>
          </Col>
          <Col>
            <Space separator={<Text className="footer-policy-sep">·</Text>}>
              <Link to="/privacy" className="footer-policy-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-policy-link">Terms of Service</Link>
            </Space>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;
